import Accordion from "../Accordion/Accordion"
import "./style.css"
import { Button } from "../../../style/Button"
import { useHistory } from "react-router-dom"
const Dashboard = () => {
    const history = useHistory();
    const dashboardNextBtnHandler = () => {
        history.push("/Pmc/pricing")
    }
    return(
        <div className="accordianSection">
            <Accordion />
        </div>
    )
}

export default Dashboard